export const Language = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5M16.5 9H1.5M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9M9 16.5C7.15905 16.5 5.66667 13.1421 5.66667 9C5.66667 4.85786 7.15905 1.5 9 1.5M9 16.5C10.8409 16.5 12.3333 13.1421 12.3333 9C12.3333 4.85786 10.8409 1.5 9 1.5M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="square"
    />
  </svg>
)

export default Language
